<script setup>
  import {ref} from "vue";

  const props = defineProps({
    value: {
      required: true,
      type: Number,
    },
    backgroundColor: {
      required: false,
      type: String,
      default: '#DFE3E5',
    },
    color: {
      required: false,
      type: String,
      default: '#0094FF',
    },
  });

  const chartOptions = ref({
    chart: {
      redrawOnParentResize: true,
      type: 'radialBar',
      selection: {
        enabled: false,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        hollow: {
          margin: 15,
          size: "60%"
        },
        track: {
          background: props.backgroundColor,
        },
        dataLabels: {
          name: {
            show: false
          },
          value: {
            offsetY: 0,
            fontSize: '25px'
          }
        }
      }
    },
    grid: {
      padding: {
        top: 0,
        right:0,
        bottom: -10,
        left: 0,
      }
    },
    stroke: {
      curve: 'smooth',
      lineCap: "round",
    },
    fill: {
      colors: [props.color],
      type: 'solid',
    },
    selection: {
      enabled: false,
    },
    labels: ['Average Results'],
  });
</script>

<template>
  <apexchart
    height="120%"
    width="100%"
    type="radialBar"
    :options="chartOptions"
    :series="[value]"
  />
</template>
